module.exports = __webpack_public_path__ + "static/media/point-15.de58a111.png";